<template>
    <div id="login-page" >
        <div class="bg" :style="bgStyle" >
            <img :src="_global.assetsRoot + '/doctor.png'" v-if="_global.isMobile" />
        </div>
        <div class="broswer-login-cont t-c" >
            <div class="broswer-login-items" >
                <div class="item" >
                    <span class="fs-2 fb segoe" >{{ $t("message.loginWith") }}</span>
                </div>

                <!-- <div class="item tip" >
                    <span class="fs-1 fb segoe v-m" :class="tip ? 'tip-show': ''" >{{ tipText }}</span>
                </div> -->

                <div class="item" >
                    <div class="other-ways" >
                        <div>
                            <a href="javascript: void(0)" @click.stop="login('google')" >
                                <img :src="_global.assetsRoot + '/icon_google.png'" />
                            </a>
                        </div>
                        <div>
                            <a href="javascript: void(0)" @click.stop="login('facebook')" >
                                <img :src="_global.assetsRoot + '/icon_fb.png'" />
                            </a>
                        </div>
                        <div>
                            <a href="javascript: void(0)" @click.stop="login('apple')" >
                                <img :src="_global.assetsRoot + '/icon_apple.png'" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="item" >
                    <div class="mid-line" >
                        <span class="fs-1 segoe" >{{ $t("message.guestLogin") }}</span>
                    </div>
                </div>
                <div class="item userid-item" >
                    <input type="text" v-model="userID" class="t-l fs-1 segoe" :placeholder="$t('message.inputUserId')" maxlength="17" @input="onInputChange" @keyup="onKeyUp" />
                    <img class="userid-tip btn" :src="_global.assetsRoot + '/button.png'" @click="showUserIDTip" />
                </div>
                <div class="item login-item" >
                    <div class="btn login-btn" @click.stop="login('guest')" >
                        <span class="fs-1-5 fb segoe" >{{ $t("message.login") }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-login-cont t-c" >
            <div class="mobile-login-items" >
                <div class="item" >
                    <div class="btn btn-bg" >
                        <a href="javascript: void(0)" @click.stop="login('google')" >
                            <span class="fs-1-5 v-m segoe" >{{ $t("message.loginWith") }}</span>
                            <img :src="_global.assetsRoot + '/icon_google.png'" />
                        </a>
                    </div>
                </div>
                <div class="item" >
                    <div class="btn btn-bg" >
                        <a href="javascript: void(0)" @click.stop="login('facebook')" >
                            <span class="fs-1-5 v-m segoe" >{{ $t("message.loginWith") }}</span>
                            <img :src="_global.assetsRoot + '/icon_fb.png'" />
                        </a>
                    </div>
                </div>
                <div class="item" >
                    <div class="btn btn-bg" >
                        <a href="javascript: void(0)" @click.stop="login('apple')" >
                            <span class="fs-1-5 v-m segoe" >{{ $t("message.loginWith") }}</span>
                            <img :src="_global.assetsRoot + '/icon_apple_w.png'" />
                        </a>
                    </div>
                </div>
                <div class="item guest-login-item" >
                    <span class="guest-login fs-1-5 fb segoe" @click.stop="showGuestLoginPopup" >{{ $t("message.guestLogin") }}</span>
                </div>
            </div>
        </div>
        <MobileGuestLogin ref="popup" @onguestlogin="checkUserID" @showTip="showTip" @showUserIDTip="showUserIDTip" ></MobileGuestLogin>
        <Tip ref="tipPopup" ></Tip>
        <FirstLogin ref="userIDTutorial" />
    </div>
</template>

<script>
import MobileGuestLogin from '../components/popup/MobileGuestLogin.vue';
import Tip from '../components/popup/Tip.vue';
import FirstLogin from '../components/popup/FirstLogin.vue';
export default {
    data() {
        return {
            userID: '',
            tip: false,
            customTip: null,
            timer: null,
            duration: 3000,
            logining: false
        }
    },
    created() {
        this.userID = this._global.userID;
    },
    mounted() {
        let params = new URLSearchParams(location.href);

    },
    computed: {
        tipText() { return this.customTip || this.$t("message.userIDErrorTip")},
        bgStyle() { return `background: url("${this._global.assetsRoot}/bg_${this._i18n.locale || 'en'}.jpg") 50% 0 no-repeat;background-size: 100% 100%;` }
    },
    methods: {
        onInputChange(e) { this.userID = this.userID.replace(/[^\d]/g, '') },
        onKeyUp(e) { if (e.keyCode === 13) this.login("guest") },
        checkUserID(data) {
            this.userID = data.userID;
            this.login("guest");
        },
        login(type) {
            if (this.logining) return;
            this.logining = true;
            setTimeout(() => {
                this.logining = false;
            }, 3000)
            if (type === "guest") {
                if (!this.userID || this.userID === "") {
                    this._global.isMobile ? this.$refs.popup.showTip(null): this.showTip(null);
                    return;
                } else if (this.userID.length !== 9 && this.userID.length !== 17) {
                    this._global.isMobile ? this.$refs.popup.showTip(this.$t("message.err_1002")): this.showTip(this.$t("message.err_1002"));
                    return;
                }
            }
            this.$emit("login", { "type": type, "userID": this.userID })
        },
        showGuestLoginPopup() {
            this.$refs.popup.show()
        },
        showTip(tip) {
            if (tip instanceof Object) tip = tip.text;
            this.customTip = tip || null;
            if (this._global.isMobile) {
                this.$refs.popup.hide();
            }
            this.$refs.tipPopup.show(this.tipText);
        },
        showUserIDTip() {
            let popup = this.$refs["userIDTutorial"];
            popup && popup.show();
        }
    },
    components: { MobileGuestLogin, Tip, FirstLogin }
}
</script>

<style lang="scss" >
@import "../assets/css/variables.scss";
#login-page {
    height: 100%;
    display: flex;
    flex-direction: row;

    .bg {
        flex: 6;
        background-size: 100% 100%;

        img {
            position: relative;
            width: 80%;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
        }
    }

    .broswer-login-cont {
        flex: 4;
        border-left: 1px solid #000;
        position: relative;

        .broswer-login-items {
            position: absolute;
            width: 75%;
            max-width: 500px;
            left: 50%;
            top: 50%;
            transform: translate3d(-50%, -50%, 0);
            -webkit-transform: translate3d(-50%, -50%, 0);

            .item {
                margin: 2.5rem 0 0 0;

                input {
                    width: 100%;
                    height: 3.5rem;
                    border: 1px solid #CCC;
                    border-radius: .6rem;
                    text-indent: 1rem;
                }

                input::placeholder {
                    font-size: 1rem;
                    font-weight: bold;
                    color: #ccc;
                }

                .login-btn {
                    width: 100%;
                    height: 3.5rem;
                    line-height: 3.5rem;
                    border-radius: .6rem;
                    background: url($assetRoot + "/button_log_bg.png") center no-repeat;
                    background-size: 100% 100%;

                    span {
                        color: #FFF;
                    }
                }

                .mid-line {
                    position: relative;

                    span {
                        background-color: #FFF;
                        padding: 0 1rem;
                        color: #CCC;
                    }
                }

                .mid-line::before {
                    content: " ";
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    left: 0%;
                    top: 50%;
                    background-color: #CCC;
                    z-index: -1;
                }

                .other-ways {
                    margin-top: 2rem;
                    display: flex;
                    flex-direction: row;

                    div {
                        flex: 1;

                        img {
                            width: 5rem;
                        }
                    }
                }
            }

            .userid-item {
                position: relative;

                .userid-tip {
                    position: absolute;
                    right: 0;
                    top: 0;
                    height: 100%;
                }
            }

            .login-item {
                margin: 2rem 0 0 0;
            }

            .tip {
                margin: 0.3rem 0 !important;
                overflow: hidden;
                height: 2.2rem;
                line-height: 2rem;

                span {
                    display: inline-block;
                    color: #F93B3B;
                    transform: translate(0, -200%);
                    -webkit-transform: translate(0, -200%);
                    transition: transform linear .3s;
                    -webkit-transition: -webkit-transform linear .3s;
                    line-height: 1rem;
                }

                .tip-show {
                    transform: translate(0, 0);
                    -webkit-transform: translate(0, 0);
                }
            }
        }
    }

    .mobile-login-cont {
        display: none;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;

        .mobile-login-items {
            margin-bottom: 3rem;

            .item {
                margin: 2rem 0;

                .guest-login {
                    padding: .5rem 0;
                    border-bottom: 1px solid #FFF;
                    color: #FFF;
                }

                .btn-bg {
                    width: 18rem;
                    height: 6rem;
                    line-height: 5.6rem;
                    background: url($assetRoot + "/button_bg.png") center no-repeat;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    vertical-align: middle;

                    span {
                        color: #FFF;
                    }

                    img {
                        height: 4rem;
                        vertical-align: middle;
                        margin-left: 1rem;
                    }
                }
            }

            .guest-login-item {
                margin-bottom: 4rem;
            }
        }
    }
}

.mobile {
    .bg {
        background: url($assetRoot + "/login_bg.jpg") center no-repeat !important;
        background-size: 100% 100% !important;

        img {
            top: 10% !important;
            transform: translate(-50%, 0) !important;
            -webkit-transform: translate(-50%, 0) !important;
        }
    }

    .mobile-login-cont {
    }

    .broswer-login-cont {
        display: none;
    }

    .mobile-login-cont {
        display: inline-block !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue